import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { CurrentDialTargetChanged } from './current-dial-target.actions';
import _ from 'lodash';
import moment from 'moment';

export interface CurrentDialTargetStateModel {
   currentDialTargetNumber: string;
   changedAt: moment.Moment;
}

@State<CurrentDialTargetStateModel>({
   name: 'currentDialTargetState',
   defaults: {
      currentDialTargetNumber: '',
      changedAt: moment(),
   },
})
@Injectable()
export class CurrentDialTargetState {
   constructor() {}

   @Selector([CurrentDialTargetState])
   public static currentDialTargetNumber(state: CurrentDialTargetStateModel): string {
      return state.currentDialTargetNumber;
   }

   @Selector([CurrentDialTargetState])
   public static currentDialTargetChangedAt(state: CurrentDialTargetStateModel): moment.Moment {
      return state.changedAt;
   }

   @Action(CurrentDialTargetChanged)
   public currentDialTargetChanged(ctx: StateContext<CurrentDialTargetStateModel>, action: CurrentDialTargetChanged) {
      ctx.patchState({
         currentDialTargetNumber: action.dialTarget,
         changedAt: moment(),
      });
   }
}
